import { Helmet } from "react-helmet-async";

/**
 * Drop into any route that should not be indexed by search engines
 * (portal pages, transactional/utility pages, token-protected views).
 * Pair with a robots.txt Disallow for the same path.
 */
export default function NoIndex() {
  return (
    <Helmet>
      <meta name="robots" content="noindex,nofollow" />
      <meta name="googlebot" content="noindex,nofollow" />
    </Helmet>
  );
}
